"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Col = exports.Row = exports.Container = exports.Layout = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var Container_1 = require("./Container");
Object.defineProperty(exports, "Container", { enumerable: true, get: function () { return Container_1.Container; } });
var Row_1 = require("./Row");
Object.defineProperty(exports, "Row", { enumerable: true, get: function () { return Row_1.Row; } });
var Col_1 = require("./Col");
Object.defineProperty(exports, "Col", { enumerable: true, get: function () { return Col_1.Col; } });
var Layout = function (_a) {
    var container = _a.container, row = _a.row, col = _a.col, props = __rest(_a, ["container", "row", "col"]);
    if (container) {
        if (row && col) {
            return (jsx_runtime_1.jsx(Container_1.Container, __assign({}, props, { className: container }, { children: jsx_runtime_1.jsx(Row_1.Row, __assign({ className: row }, { children: jsx_runtime_1.jsx(Col_1.Col, __assign({ className: col }, { children: props.children }), void 0) }), void 0) }), void 0));
        }
        if (row) {
            return (jsx_runtime_1.jsx(Container_1.Container, __assign({}, props, { className: container }, { children: jsx_runtime_1.jsx(Row_1.Row, __assign({ className: row }, { children: props.children }), void 0) }), void 0));
        }
        return (jsx_runtime_1.jsx(Container_1.Container, __assign({}, props, { className: container }, { children: props.children }), void 0));
    }
    if (row) {
        if (col) {
            return (jsx_runtime_1.jsx(Row_1.Row, __assign({}, props, { className: row }, { children: jsx_runtime_1.jsx(Col_1.Col, __assign({ className: col }, { children: props.children }), void 0) }), void 0));
        }
        return (jsx_runtime_1.jsx(Row_1.Row, __assign({}, props, { className: row }, { children: props.children }), void 0));
    }
    if (col) {
        return (jsx_runtime_1.jsx(Col_1.Col, __assign({}, props, { className: col }, { children: props.children }), void 0));
    }
    return jsx_runtime_1.jsx(jsx_runtime_1.Fragment, { children: props.children }, void 0);
};
exports.Layout = Layout;
//# sourceMappingURL=index.js.map